import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextPurchase } from '../Purchase';
import { User } from '../../../../models/user.model';
import { AppService } from '../../../../models/app.service.model';
import { Company } from '../../../../models/company.model';
import { Settings } from '../../../../models/settings.model';
import { Contact }  from '../../../../models/contact.model';
import { TreasuryAccount } from '../../../../models/treasury.account.model';
import { AccountingAccount } from '../../../../models/accounting.account.model';
import { Service } from '../../../../models/service.model';
import { Product } from '../../../../models/product.model';

export interface ExpensePageProps {};

type ContexType = {
  asideMinimize: string,
  setAsideMinimize: Dispatch<SetStateAction<string>>,
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  userLoggedIn: User | null,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  accountingAccountsForCompany: AccountingAccount[] | null,
  accountingTaxAccountsForCompany: AccountingAccount[] | null,
  accountingExpenseAccountsForCompany: AccountingAccount[] | null,
  treasuryAccountsForCompany: TreasuryAccount[] | null,
  contactsForCompany: Contact[] | null,
  servicesForCompany: Service[] | null,
  productsForCompany: Product[] | null,
  loadSettingsForCompany: Function,
  loadContactsForCompany: Function
};

const ExpensePage: React.FunctionComponent<ExpensePageProps> = props => {
  const {asideMinimize, setAsideMinimize, setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, accountingAccountsForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, accountingTaxAccountsForCompany, accountingExpenseAccountsForCompany, loadSettingsForCompany, loadContactsForCompany} = UseOutletContextPurchase()

  return (
    <Outlet context={{asideMinimize, setAsideMinimize, setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, accountingAccountsForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, accountingTaxAccountsForCompany, accountingExpenseAccountsForCompany, loadSettingsForCompany, loadContactsForCompany}}></Outlet>
  );
}

export function UseOutletContextExpense() {
  return useOutletContext<ContexType>()
};

export default ExpensePage;
